export const columnLabels = {
    id: 'ID',
    vacancy_id: 'Вакансия',
    author: 'Автор заявки',
    created_at: 'Дата создания',
    assignee_id: 'Исполнитель',
    is_template: 'Черновик',
    status: 'Статус',
    submission_date: 'Дата подачи',
    organisation: 'Компания',
    department: 'Отдел',
    city: 'Город',
    planned_start_date: 'Планируемая дата выхода',
    author_position: 'Должность автора',
    job_title: 'Название должности',
    positions_count: 'Количество позиций',
    rate: 'Ставка',
    vacancy_reason: 'Причина открытия вакансии',
    supervisors: 'Руководитель',
    subordinates_count: 'Количество подчинённых',
    is_material_responsible: 'Материально ответственное лицо',
    tasks: 'Основные задачи',
    expected_results: 'Ожидаемые результаты',
    functional_responsibilities: 'Функциональные обязанности',
    reporting_details: 'Отчетность',
    work_schedule: 'График работы',
    work_start_time: 'Время начала работы',
    work_end_time: 'Время окончания работы',
    field_vs_office: 'Место работы',
    requires_travel: 'Требуются командировки',
    travel_details: 'Детали командировок',
    requires_relocation: 'Требуется переезд',
    salary_structure: 'Структура оплаты',
    trial_salary: 'Зарплата на испытательный срок',
    post_trial_salary: 'Зарплата после испытательного срока',
    compensate_phone: 'Компенсация за телефон',
    compensate_car: 'Компенсация за авто',
    workplace_address: 'Адрес места работы',
    gender: 'Пол',
    age: 'Возраст',
    marital_status: 'Семейное положение',
    requires_license: 'Требуется водительское удостоверение',
    license_categories: 'Категории ВУ',
    requires_car: 'Наличие личного авто',
    education_levels: 'Уровень образования',
    computer_skills_level: 'Навыки ПК',
    skills_1c: 'Навыки работы в 1С',
    software_skills: 'Навыки работы с ПО',
    language_skills: 'Знание языков',
    experience_description: 'Опыт работы',
    personal_traits: 'Личностные качества',
    professional_skills: 'Профессиональные навыки',
    preferred_companies: 'Желаемые компании',
    unwanted_companies: 'Нежелательные компании',
    other_conditions: 'Прочие условия',
    actions: 'Действия'
};

export const STATUSES = {
    pending: {
        title: 'На согласовании',
        color: '#1890ff' // Синий - ожидание решения
    },
    new: {
        title: 'Новая',
        color: '#52c41a' // Зеленый - активная, новая заявка
    },
    in_progress: {
        title: 'В работе',
        color: '#fa8c16' // Оранжевый - активная работа
    },
    closed: {
        title: 'Закрыта',
        color: '#8c8c8c' // Серый - завершена
    },
    withdrawn: {
        title: 'Отозвана',
        color: '#722ed1' // Фиолетовый - отозвана автором
    },
    rejected: {
        title: 'Отклонена',
        color: '#f5222d' // Красный - отклонена
    },
    archived: {
        title: 'Архив',
        color: '#8b572a' // Коричневый - архивная
    },
    template: {
        title: 'Черновик',
        color: '#595959' // Темно-серый - черновик
    }
};

